import Preview from 'components/layout/preview';
import Header from 'components/layout/header';
import Footer from 'components/layout/footer';
import TypeForm from 'components/sections/typeForm';
import { useGlobalModules } from 'contexts';
import Head from 'next/head';
import CartDrawer from 'components/cart/cartDrawer/cartDrawer';
import styles from './layout.module.scss';
import SalonSelectorModal from './salonSelectorModal';
import ConfirmWishlistPopup from './confirmWishlistPopup';
import KickbackfeePopup from './kickbackfeePopup';
import LocalePopup from './localePopup';
import MenuDrawer from './menuDrawer';

const Layout = ({ children, locale, previewData, pageData, is404, pageTitle }) => {
  const globalModules = useGlobalModules();

  const { hideLayout } = pageData || {};
  const typeFormSettings = globalModules?.secondpartsettings?.embedTypeform?.sections?.[0];
  const doofinderSettings = globalModules?.settings?.doofinder || {};

  return (
    <>
      <Head>
        {pageTitle && <title>{pageTitle} | Keune Haircosmetics</title>}
        {doofinderSettings.enabled && doofinderSettings.hashID && (
          <script
            src={`https://ap1-config.doofinder.com/2.x/${doofinderSettings.hashID}.js`}
            async
          />
        )}
      </Head>
      <a href="#main-content" className={styles.skipLink}>
        {globalModules?.translations?.accessibility?.skipToContent || 'Skip to content'}
      </a>
      {hideLayout ? null : <Header locale={locale} is404={is404} pageData={pageData} />}
      <main className={styles.main} id="main-content">
        {children}
      </main>
      <MenuDrawer locale={locale} />
      <div
        id="a11y-announcer"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      />
      {hideLayout ? null : <Footer locale={locale} pageData={pageData} is404={is404} />}
      {previewData && <Preview message={previewData.message} />}
      {typeFormSettings?.typeFormId && <TypeForm data={typeFormSettings} />}
      <CartDrawer locale={locale} />
      <SalonSelectorModal locale={locale} />
      <KickbackfeePopup />
      <ConfirmWishlistPopup />
      <LocalePopup locale={locale} pageData={pageData} />
    </>
  );
};
export default Layout;
